import type { ScreenOnTime } from '@/entities/screen';

export const DEFAULT_TIMEFRAME: ScreenOnTime = {
  from: { hours: '09', minutes: '00' },
  to: { hours: '17', minutes: '00' },
};

export const START_HOURS = Array.from({ length: 24 }, (_, hour) =>
  String(hour).padStart(2, '0')
);

export const END_HOURS = [...START_HOURS, '24'];

export const MINUTES = Array.from({ length: 60 }, (_, minute) =>
  String(minute).padStart(2, '0')
);
